import { render, staticRenderFns } from "./ProjectNewPage.vue?vue&type=template&id=6e48e9a2&"
import script from "./ProjectNewPage.vue?vue&type=script&lang=ts&"
export * from "./ProjectNewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports